import { InstallationType } from "@repo/api";
import { FilterCheckbox, translateInstallationType } from "@repo/ui";
import { hasItems, isChecked } from "@repo/utils";

import { FilterListContainer } from "./FilterListContainer";
import { type FilterItemsProps } from "./type";

const installationTypes: InstallationType[] = [InstallationType.KITCHEN];

export const InstallationTypeFilter = ({
  actions,
  filters,
}: FilterItemsProps) => {
  return (
    <FilterListContainer id="installation-type-filter">
      {hasItems(installationTypes) &&
        installationTypes.map((type) => (
          <FilterCheckbox
            key={type}
            id={type}
            value={type}
            label={translateInstallationType(type) ?? "-"}
            checked={isChecked(filters.installationType, type)}
            onCheckFilter={actions.setInstallationType}
          />
        ))}
    </FilterListContainer>
  );
};
